import { render, staticRenderFns } from "./assign-by-email-preview.vue?vue&type=template&id=1f9818fe&scoped=true&"
import script from "./assign-by-email-preview.vue?vue&type=script&lang=js&"
export * from "./assign-by-email-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9818fe",
  null
  
)

export default component.exports